import {  GET_FAULT_HISTORY,DETAIL_UPDATE_SUCCESS, DETAIL_UPDATE_ERROR, CLEAR_STATE } from './types';

export const getFaultHistory = (params)=> {
  return {
    type: GET_FAULT_HISTORY,
    params
  }
}

export const faultDetailUpdateSuccess =  (payload) => {
  return {
    type: DETAIL_UPDATE_SUCCESS,
    payload
  }
}

export const faultDetailUpdateErr = (params)=> {
  return {
    type: DETAIL_UPDATE_ERROR,
    params
  }
}

export const clearArchiveState = ()=> {
  return {
    type: CLEAR_STATE,
  }
}